import React from 'react';
import { Spinner, SpinnerSize } from '@fluentui/react';
import './LoadingScreen.css';
import loadingScreenImage from './LoadingScreen.png';

export interface ILoadingScreenProps {
  message?: string;
  backgroundColor: string;
}

export const LoadingScreen: React.FC<ILoadingScreenProps> = ({ message = 'Loading...', backgroundColor }) => (
  <div className="loading-screen" style={{ backgroundColor }}>
    <div className="loading-content">
      <img src={loadingScreenImage} alt="Loading" className="loading-image" />
      <Spinner size={SpinnerSize.large} label={message} />
    </div>
  </div>
);
